"use strict";
/**
 * Url modules.
 * @module url

 * @description support server & client & miniprogram side
 * @see https://gitlab.cdfsunrise.com/frontend/core/-/tree/main/packages/utils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathJoin = exports.getUrlPathmain = exports.getUrlBasename = exports.getUrlExtname = exports.getUrlPathKey = exports.getUrlHash = exports.getUrlSearch = exports.parseUrl = exports.delUrl = exports.setUrl = exports.getUrl = void 0;
var config_1 = require("@fe/config");
var zaxUtil = {
    strToObj: function (query) {
        return query.split('&').reduce(function (sum, item) {
            var arr = item.split('=');
            arr[0] && (sum[arr[0]] = arr[1]);
            return sum;
        }, {});
    },
    objToStr: function (params) {
        return Object.keys(params)
            .reduce(function (sum, item) {
            /* istanbul ignore next */
            if (item) {
                if (params[item] !== null && params[item] !== undefined && params[item] !== '') {
                    sum.push("".concat(item, "=").concat(params[item]));
                }
            }
            return sum;
        }, [])
            .join('&');
    },
    port: function (protocol) {
        /* istanbul ignore next */
        switch (protocol) {
            case 'http:':
                return '80';
            case 'https:':
                return '443';
            default:
                /* istanbul ignore next */
                if (!(0, config_1.isMiniApp)()) {
                    return location.port || '80';
                }
                return '80';
        }
    },
};
/**
 * get value from url search part mode
 *
 * @name getUrl
 * @function
 * @example
 * ```js
 * getUrl("pages/index?id=0&v=1", 'id')
 * => 0
 * ```
 * @param key {String} key
 * @param url {String} url
 * @returns {String} string of result
 */
function getUrl(url, key) {
    if (arguments.length === 1) {
        /* istanbul ignore next */
        if (!(0, config_1.isMiniApp)()) {
            key = url;
            url = location.href;
        }
        else {
            //server side & miniprogram
        }
    }
    /* istanbul ignore next */
    if (!url) {
        // console.log('url must be a string')
        return '';
    }
    if (!key) {
        // console.log('key must be a string')
        return '';
    }
    var searchObj = getUrlSearch(url);
    return searchObj[key] || '';
}
exports.getUrl = getUrl;
/**
 *
 * set & get new url
 *
 * @example
 *
 * ```js
 * setUrl("pages/foo/index?id=2", 'foo','bar')
 * => pages/foo/index?id=2&foo=bar
 * ```
 * ```js
 * setUrl("pages/foo/index?id=2", {"foo":"bar"})
 * => pages/foo/index?id=2&foo=bar
 * ```
 *
 * @name setUrl
 * @function
 * @override
 * @param url {String} url
 * @param key {String} key
 * @param value {String} value
 * @returns {String} new url
 *
 */
function setUrl(url, key, value) {
    if (value === void 0) { value = ''; }
    if (!key) {
        return url;
    }
    var searchObj = getUrlSearch(url);
    if (Object.keys(key).length && key.constructor === Object) {
        Object.assign(searchObj, key);
    }
    else {
        searchObj[key] = value;
    }
    var res = zaxUtil.objToStr(searchObj);
    var hash = parseUrl(url).hash;
    var tmp = url.replace(hash, '');
    var askIdx = tmp.indexOf('?');
    askIdx = askIdx > -1 ? askIdx : tmp.length;
    var left = url.slice(0, askIdx);
    var mid = res ? '?' + res : '';
    var right = hash;
    return left + mid + right;
}
exports.setUrl = setUrl;
/**
 * delete key & get new url
 *
 * @example
 * ```js
 * delUrl("pages/foo/index?id=2", 'id')
 * => pages/foo/index
 * ```
 *
 * @param url {String} url
 * @param key {String} key
 * @returns {String} new url
 */
function delUrl(url, key) {
    return setUrl(url, key, '');
}
exports.delUrl = delUrl;
/**
  * get key of value of url
  *
  * @example
  * ```js
  * parseUrl("https://demo.com/foo/index?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
  * => {
   host: 'demo.com',
   hostname: 'demo.com',
   href: mixUrl,
   origin: 'https://demo.com',
   pathname: '/foo/index',
   port: '443',
   protocol: 'https:',
   hash: '#/path/id=3?bizOrigin=bar',
   search: '?bizOrigin=foo&other=quz'
 }
  * ```
  *
  * @param url {String} url
  * @returns {UrlDescriptor} parse object
  */
function parseUrl(url) {
    if (!url) {
        // console.log('url must be a string')
        return {
            href: '',
            hash: '',
            search: '',
            pathname: '',
        };
    }
    /* istanbul ignore next */
    if (!(0, config_1.isMiniApp)()) {
        // client side
        var a = document.createElement('a');
        a.href = url;
        return {
            hash: a.hash,
            host: a.host || window.location.host,
            hostname: a.hostname || window.location.hostname,
            href: a.href,
            origin: a.origin,
            pathname: a.pathname.charAt(0) != '/' ? '/' + a.pathname : a.pathname,
            port: '0' === a.port || '' === a.port ? zaxUtil.port(a.protocol) : a.port,
            protocol: !a.protocol || ':' == a.protocol ? window.location.protocol : a.protocol,
            search: a.search || '',
        };
    } /* istanbul ignore next */
    else {
        //mini program & server side
        var hash = url.slice(url.lastIndexOf('#') > -1 ? url.lastIndexOf('#') : url.length) || '';
        var tmp = url.replace(hash, '');
        var search = tmp.slice(tmp.lastIndexOf('?') > -1 ? tmp.lastIndexOf('?') : tmp.length) || '';
        return {
            pathname: url.replace(search, '').replace(hash, ''),
            href: url,
            hash: hash,
            search: search,
        };
    }
}
exports.parseUrl = parseUrl;
/**
 * get url search part
 *
 * @example
 * ```js
 * getUrlSearch("https://demo.com/foo/ndex?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
 * => { bizOrigin: 'foo', other: 'quz' }
 * ```
 *
 * @param url {String} url
 * @returns {IKV} url search part
 */
function getUrlSearch(url) {
    var search = parseUrl(url).search.replace('?', '');
    if (!search) {
        // console.log('no search char');
        return {};
    }
    return zaxUtil.strToObj(search);
}
exports.getUrlSearch = getUrlSearch;
/**
 * get url hash part without # prefix
 *
 * @example
 * ```js
 * getUrlHash("https://demo.com/foo/index?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
 * => /path/id=3?bizOrigin=bar
 * ```
 *
 * @param url {String} url
 * @returns {String} url hash part
 */
function getUrlHash(url) {
    var hash = parseUrl(url).hash.replace('#', '');
    if (!hash) {
        console.log('no hash char');
        return '';
    }
    return hash;
}
exports.getUrlHash = getUrlHash;
/**
 * get last url part of key
 *
 * @example
 * ```js
 * getUrlPathKey("https://demo.com/foo/index?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
 * => index
 *
 *
 * getUrlPathKey("https://demo.com/foo/index/p123?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar",1)
 * => 123
 *
 *
 * getUrlPathKey("https://demo.com/foo/index/p-123?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar",2)
 * => 123
 *
 * ```
 *
 * @param url {String} url
 * @param pos {Number} pos
 * @returns {String} key path
 */
function getUrlPathKey(url, pos) {
    if (pos === void 0) { pos = 0; }
    var pathname = parseUrl(url).pathname || '';
    var last = pathname.split('/').pop() || '';
    return last.slice(pos);
}
exports.getUrlPathKey = getUrlPathKey;
/**
 * get extname from path
 *
 * @example
 * ```js
 * getUrlExtname("/test/something/file.txt")
 * => .txt
 *
 * getUrlExtname("/test/something/file")
 * => '' // empty
 *
 * ```
 *
 * @param url {String} url
 * @returns {String} extname
 */
function getUrlExtname(url) {
    var last = getUrlBasename(url);
    if (last && last.indexOf('.') > -1) {
        var arr = last.split('.');
        /* istanbul ignore next */
        var ext = arr.pop() || '';
        /* istanbul ignore next */
        if (ext) {
            return '.' + ext;
        }
    }
    return '';
}
exports.getUrlExtname = getUrlExtname;
/**
 * get basename from path
 *
 * @example
 * ```js
 * getUrlBasename("https://demo.com/foo/index?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
 * => index
 *
 * getUrlBasename("https://demo.com/foo/dairy.txt?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
 * => dairy.txt
 * ```
 *
 * @param url {String} url
 * @returns {String} key path
 */
function getUrlBasename(url) {
    var pathname = parseUrl(url).pathname || '';
    var last = pathname.split('/').pop();
    return last || '';
}
exports.getUrlBasename = getUrlBasename;
/**
 * remove host and left pathname + search + hash
 *
 * @example
 * ```js
 * getUrlPathmain("https://demo.com/foo/index?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar")
 * => /foo/index?bizOrigin=foo&other=quz#/path/id=3?bizOrigin=bar
 * ```
 *
 * @param url {String} url
 * @returns {String} key path
 */
function getUrlPathmain(url) {
    var info = parseUrl(url);
    var pathmain = info.pathname + info.search + info.hash;
    return pathmain;
}
exports.getUrlPathmain = getUrlPathmain;
/**
 * path join
 * @function
 * @example
 *
 * ``` js
pathJoin('', 'a', 'b', 'c') => a/b/c
pathJoin('/', 'a', 'b', 'c') => /a/b/c
pathJoin('/', 'a', 'b/X', 'c') => /a/b/X/c
pathJoin('/', 'a', 'b/X/', 'c/') => /a/b/X/c
pathJoin('//', '/a', '/b/X/', '/c/') => /a/b/X/c

pathJoin('https://cdn.com', 'a/x', 'b', 'c') => https://cdn.com/a/x/b/c
pathJoin('https://cdn.com', 'a//x', 'b', 'c/') => https://cdn.com/a/x/b/c
 * ```
 *
 * @param path string[]
 * @returns string
 */
var pathJoin = function () {
    var path = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        path[_i] = arguments[_i];
    }
    var delimiter = '/';
    var first = path[0].trim();
    var arr = path.reduce(function (sum, item, index) {
        if (item) {
            if (index === 0 && item.includes('://')) {
                // http path join
                sum.push(item);
            }
            else {
                var tmp = item.split(delimiter);
                if (tmp && tmp.length) {
                    tmp.map(function (sub) {
                        if (sub && sub !== delimiter) {
                            sum.push(sub);
                        }
                    });
                }
            }
        }
        return sum;
    }, []);
    var ret = arr.join(delimiter);
    return first.startsWith('/') ? '/' + ret : ret;
};
exports.pathJoin = pathJoin;
//# sourceMappingURL=index.js.map